import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { MultiSelectModule } from 'primeng/multiselect'
import { IftaLabel } from 'primeng/iftalabel'
import { AlbertBaseControlDirective } from '@directives/albert-base-control.directive'

@Component({
  selector: 'albert-multiselect',
  standalone: true,
  imports: [ReactiveFormsModule, MultiSelectModule, IftaLabel],
  templateUrl: './albert-multiselect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertMultiselectComponent extends AlbertBaseControlDirective {
  public readonly dataKey = input<string>()
  public readonly optionLabel = input<string>()
  public readonly filter = input<boolean>(false)
  public readonly maxSelectedLabels = input<number>(3)
  public readonly dataTest = input<string>('')

  public readonly filterEvent = output<unknown>()
  public readonly modelChange = output<unknown>()
}
